/** @format */

import template from './gb-background-widget.html';
import './gb-background-widget.scss';

export const GbBackgroundWidgetComponent = {
    template,
    require: {
        gbApp: '^^',
        gbPresenter: '^^',
    },
    bindings: {
        widget: '=',
    },
    controller: class GbBackgroundWidgetComponent {
        constructor($gbAuctionImage, $gbTask, $log, $ccToast, LoadingHelper, $ccLoading) {
            'ngInject';

            this.$gbAuctionImage = $gbAuctionImage;
            this.$gbTask = $gbTask;
            this.$log = $log;
            this.$ccToast = $ccToast;

            this.loadingHelper = new LoadingHelper();
            this.isLoading = () => this.loadingHelper.isLoading();
            this.getLoadingMessage = () => this.loadingHelper.getFirstMessage();
            this.loadingWatcher = $ccLoading.bind(this.isLoading, this.getLoadingMessage);
        }

        saveProjector() {
            return this.gbApp.getProjector().$save();
        }

        clearBackgroundImage() {
            let projector = this.gbApp.getProjector();
            projector.background_image = null;
            return projector.$save();
        }

        handleFileUpload() {
            if (!!this.imageToUpload) {
                let loader = this.loadingHelper.push('UPLOADING_IMAGE');

                return this.$gbAuctionImage
                    .uploadImage(this.imageToUpload, {
                        url_name: this.gbApp.getAuctionUrl(),
                    })
                    .then((response) => {
                        this.$log.info('Started Upload Task...', response);

                        return this.$gbTask
                            .get({
                                uuid: response.blackboard_uuid,
                            })
                            .$promise.then((data) => {
                                let auctionImage = data.results;
                                this.$log.info('Image Upload Complete!', data);

                                this.$gbAuctionImage.cache.push(auctionImage);
                                let projector = this.gbApp.getProjector();
                                projector.background_image = auctionImage;
                                return projector.$save();
                            });
                    })
                    .catch((err) => {
                        this.$ccToast.error(err);
                        throw err;
                    })
                    .finally(() => {
                        loader();
                    });
            }
        }

        $onDestroy() {
            this.loadingWatcher();
        }
    },
};
